export const GET_SEARCH_SUGGESTION_LIST = 'GET_SEARCH_SUGGESTION_LIST';
